/* eslint-disable no-lone-blocks */
import axios from 'axios'
import {createSlice, createAsyncThunk} from '@reduxjs/toolkit'
import {toast} from 'react-toastify'
import {stopLoading} from '../../../../Redux/FrontEnd/Loading/LoadingSlice'
import {ProfileDetailData} from '../../../../Redux/AdminPanel/ProfileDetailsSlice'
import {ENV} from '../../../../Utils/_helpers/EnvHelper'

const API_URL = ENV().REACT_APP_API_URL
const initialState: any = {
  FEdashboardCount: [],
  FEdashboardLeadGraph: [],
  FEdashboardInboundMsg: [],
  FEDashboardActivityGraph: [],
  FEDashboardActivity: [],
  FEDashboardCalander: [],
  FEDashboardState: {},
  FrontendDashboardGraph: {},
}

export const FrontendDashboardCalanderData: any = createAsyncThunk(
  '/FrontendDashboardCalanderData',
  async (data: any, thunkApi: any) => {
    const response: any = await axios.get(`${API_URL}report/getDashboardCalendatData`, {
      params: data,
      headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
    })
    return response?.data
  }
)
export const FrontendDashboardActivity: any = createAsyncThunk(
  '/FrontendDashboardActivity',
  async (data: any, thunkApi: any) => {
    const response: any = await axios.get(`${API_URL}report/allCampaignListReport`, {
      params: data,
      headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
    })
    return response?.data
  }
)
export const FrontendDashboardActivityGraph: any = createAsyncThunk(
  '/FrontendDashboardActivityGraph',
  async (data: any, thunkApi: any) => {
    const response: any = await axios.get(`${API_URL}report/getDashboardActivityOverviewGraph`, {
      params: data,
      headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
    })
    return response?.data
  }
)
export const FrontendDashboardCount: any = createAsyncThunk(
  '/FrontendDashboardCount',
  async (data: any, thunkApi: any) => {
    const response: any = await axios.get(`${API_URL}report/getDashboardOverviewCount`, {
      params: data,
      headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
    })
    return response?.data
  }
)
export const FrontendDashboardLeadGraph: any = createAsyncThunk(
  '/FrontendDashboardLeadGraph',
  async (data: any, thunkApi: any) => {
    const response: any = await axios.get(`${API_URL}report/getDashboardLeadsGraph`, {
      params: data,
      headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
    })
    return response?.data
  }
)
export const FrontendDashboardMsgInbound: any = createAsyncThunk(
  '/FrontendDashboardMsgInbound',
  async (data: any, thunkApi: any) => {
    const response: any = await axios.get(`${API_URL}report/getDashboardRecentInboundMessages`, {
      params: data,
      headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
    })
    return response?.data
  }
)
export const FrontendDashboardState: any = createAsyncThunk(
  '/FrontendDashboardState',
  async (data: any, thunkApi: any) => {
    const response: any = await axios.get(`${API_URL}report/getDashboardClickCount`, {
      params: data,
      headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
    })
    return response?.data
  }
)
export const FrontendDashboardGraph: any = createAsyncThunk(
  '/FrontendDashboardGraph',
  async (data: any, thunkApi: any) => {
    const response: any = await axios.get(`${API_URL}report/getDashboardGraph`, {
      params: data,
      headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
    })
    return response?.data
  }
)

const FEDashboardData = createSlice({
  name: 'FEDashboardData',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(FrontendDashboardCount.fulfilled, (state, {payload}) => {
      return {...state, FEdashboardCount: payload}
    })
    builder.addCase(FrontendDashboardLeadGraph.fulfilled, (state, {payload}) => {
      return {...state, FEdashboardLeadGraph: payload}
    })
    builder.addCase(FrontendDashboardMsgInbound.fulfilled, (state, {payload}) => {
      return {...state, FEdashboardInboundMsg: payload}
    })
    builder.addCase(FrontendDashboardActivityGraph.fulfilled, (state, {payload}) => {
      return {...state, FEDashboardActivityGraph: payload}
    })
    builder.addCase(FrontendDashboardActivity.fulfilled, (state, {payload}) => {
      return {...state, FEDashboardActivity: payload}
    })
    builder.addCase(FrontendDashboardCalanderData.fulfilled, (state, {payload}) => {
      return {...state, FEDashboardCalander: payload}
    })
    builder.addCase(FrontendDashboardState.fulfilled, (state, {payload}) => {
      return {...state, FEDashboardState: payload}
    })
    builder.addCase(FrontendDashboardGraph.fulfilled, (state, {payload}) => {
      return {...state, FrontendDashboardGraph: payload}
    })
  },
})

export const getFEdashboardCount = (state: any) => state?.FEDashboard?.FEdashboardCount?.data
export const getFEdashboardLeadGraphData = (state: any) =>
  state?.FEDashboard?.FEdashboardLeadGraph?.data
export const getFEdashboardInboundMsgData = (state: any) =>
  state?.FEDashboard?.FEdashboardInboundMsg?.data
export const getFEdashboardActivityGraph = (state: any) =>
  state?.FEDashboard?.FEDashboardActivityGraph?.data?.[0]
export const getFEdashboardActivity = (state: any) => state?.FEDashboard?.FEDashboardActivity?.data
export const getFEdashboardCalander = (state: any) => state?.FEDashboard?.FEDashboardCalander?.data
export const getFEDashboardState = (state: any) => state?.FEDashboard?.FEDashboardState?.data
export const getFEDashboardGraph = (state: any) => state?.FEDashboard?.FrontendDashboardGraph?.data

export default FEDashboardData.reducer
